export default "__VITE_ASSET__uT8SnaZY__"